import { render, staticRenderFns } from "./monaco-editor.vue?vue&type=template&id=61df2344&scoped=true"
import script from "./monaco-editor.vue?vue&type=script&lang=js"
export * from "./monaco-editor.vue?vue&type=script&lang=js"
import style0 from "./monaco-editor.vue?vue&type=style&index=0&id=61df2344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61df2344",
  null
  
)

export default component.exports